import {
  type Branding,
  ChatAvailability,
  ClientName,
  I18nNamespace,
  TranslationLanguage,
} from "@hopper-b2b/types";

export const branding: Branding = {
  clientName: ClientName.PERKSPOT,
  currencies: [
    {
      locale: "en-US",
      code: "USD",
      symbol: "$",
    },
  ],
  contactSupport: {
    chatAvailability: ChatAvailability.None,
    displaySupportNumber: "",
    supportNumber: "",
  },
  [I18nNamespace.translation]: {
    [TranslationLanguage.en]: {
      portalName: "PerkSpot",
      preferredCountryCode: "US",
      preferredAreaCode: "+1",
      rewardsPriceFormatterKey: "{{amount}} pts",
      "@rewardsPriceFormatterKey": {
        description:
          "text - A number of points. 'pts' is an abbreviation for 'points'. PH({{amount}}|100|number of points)",
      },
      /** TODO: This should not be mandatory **/
      urls: {
        termsAndConditions: "/termsAndConditions",
        privacyPolicy: "/privacyPolicy",
      },
    },
  },
  supportedLanguages: [{ key: "en", name: "English", label: "US English" }],
  merchantPayments: "",
};
